/* unplugin-vue-components disabled */import { render } from "./StereoProjectionRender.vue?vue&type=template&id=1e84ff9f&scoped=true"
import script from "./StereoProjectionRender.vue?vue&type=script&lang=js"
export * from "./StereoProjectionRender.vue?vue&type=script&lang=js"

import "./StereoProjectionRender.vue?vue&type=style&index=0&id=1e84ff9f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e84ff9f"]])

export default __exports__